import { makeStyles } from 'tss-react/mui';
import { colors, spacing } from '../../styles/jss/variables';
const generateCommonModalStyles = (theme, params) => ({
    modal: {
        [theme.breakpoints.up('sm')]: {
            '& .MuiDialog-paperFullScreen': { height: '100%' },
            '& .MuiDialogContent-root': {
                overflowY: 'hidden',
                '@media(orientation: landscape)': {
                    overflowY: 'initial !important',
                },
                marginTop: 0,
                height: '100%',
                [theme.breakpoints.between('md', 'lg')]: {
                    marginTop: (params === null || params === void 0 ? void 0 : params.isShowDatePicker) ? '-25px' : `-${spacing.xl}`,
                },
                [theme.breakpoints.up('lg')]: {
                    marginTop: (params === null || params === void 0 ? void 0 : params.isShowDatePicker) ? '-70px' : '-98px',
                },
            },
            '& form': {
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
            },
        },
        '& .MuiPaper-root': {
            '& header': {
                alignItems: 'center',
                margin: `${spacing.small} ${spacing.small} ${spacing.medium} 20px`,
                padding: 0,
                [theme.breakpoints.up('sm')]: {
                    margin: `${spacing.medium} ${spacing.medium} ${spacing.medium} 40px`,
                    alignItems: theme.isFlyingFlowers ? 'flex-start' : 'flex-end',
                },
                [theme.breakpoints.up('md')]: {
                    margin: `${spacing.large} ${spacing.medium} ${spacing.medium} ${spacing.small}`,
                },
                '& h3': {
                    padding: 0,
                    [theme.breakpoints.up('md')]: {
                        paddingTop: spacing.xs,
                    },
                },
            },
            [theme.breakpoints.up('md')]: {
                padding: 0,
                paddingBottom: '52px',
                width: '100%',
                maxWidth: '1336px',
                maxHeight: '90vh',
                left: 0,
            },
        },
        '& .MuiAutocomplete-listbox': {
            maxHeight: '25vh',
            [theme.breakpoints.up('md')]: {
                maxHeight: '18vh',
            },
        },
    },
});
const useStyles = makeStyles()((theme, params) => (Object.assign(Object.assign({}, generateCommonModalStyles(theme, params)), { modalTitle: Object.assign(Object.assign({}, theme.typography.small_regular), { marginBottom: '0', marginLeft: '0', color: colors.supplementary.black, [theme.breakpoints.up('md')]: Object.assign(Object.assign({ marginLeft: '66px', display: 'flex' }, theme.typography.medium_regular), { justifyContent: 'left', marginBottom: 0 }), [theme.breakpoints.up('lg')]: {
            marginLeft: '120px',
            display: 'flex',
            justifyContent: 'left',
            marginBottom: 0,
        } }), customizeTitle: Object.assign(Object.assign(Object.assign({}, theme.typography.small_regular), theme.typographySpacing.none), { [theme.breakpoints.up('md')]: Object.assign(Object.assign({}, theme.typography.medium_regular), { marginBottom: (params === null || params === void 0 ? void 0 : params.showInternationalLink) ? '10px' : spacing.large }) }), internationalModal: {
        '& .MuiPaper-root': {
            height: '100%',
            paddingBottom: spacing.xs,
            '& header': {
                alignItems: 'center',
                margin: `${spacing.small} ${spacing.small} ${spacing.medium} 20px`,
                padding: 0,
                [theme.breakpoints.up('sm')]: {
                    margin: `${spacing.medium} ${spacing.medium} ${spacing.large} 40px !important`,
                    alignItems: theme.isFlyingFlowers ? 'flex-start' : 'flex-end',
                },
                [theme.breakpoints.up('md')]: {
                    margin: `${spacing.medium} ${spacing.medium} 0 ${spacing.small} !important`,
                },
                '& h3': {
                    padding: 0,
                },
            },
            [theme.breakpoints.up('md')]: {
                padding: 0,
                paddingBottom: '52px',
                width: '100%',
                maxWidth: '1336px',
                maxHeight: '90vh',
                left: 0,
                height: '402px',
            },
        },
        '& .MuiDialogContent-root': {
            marginTop: 0,
        },
    } })));
export default useStyles;
